import { currency } from "config";
import styles from "./SummaryLineItem.module.scss";

export default function SummaryLineItem({
  title,
  unitPrice,
  people,
  duration,
}) {
  return (
    <article className={`${styles.lineItem}`}>
      {/* <div className={`${styles.titleContainer}`}>
        <span className={`${styles.title}`}>{title}</span>
      </div> */}

      <div className={`${styles.priceBreakdown}`}>
        <div className={`${styles.detailsColumn}`}>
          <span className={`${styles.priceDetail}`}>{people * duration}</span>
          <span> x </span>
          <span className={`${styles.priceDetail}`}>{title}</span>{" "}
          <span> @ </span>
          <span className={`${styles.priceDetail}`}>
            {currency.symbol}
            {unitPrice}
          </span>
        </div>
        <div className={`${styles.pricingColumn}`}>
          <span className={`${styles.priceDetail}`}>{currency.symbol}</span>
          <span className={`${styles.priceDetail}`}>
            {people * duration * unitPrice}
          </span>
        </div>
      </div>
    </article>
  );
}
